import { Tooltip } from '@prenuvo/halo';

import { usePatientPermissionsAndDetails } from './use-header-permissions.hook';

export function PrenuvoId() {
  const { patientPrenuvoID, truncatedPatientID } = usePatientPermissionsAndDetails();

  return (
    <Tooltip content={patientPrenuvoID} side="bottom">
      <span className="border-r-2 px-2 py-1" data-testid="patient-id">
        Prenuvo ID: {truncatedPatientID}
      </span>
    </Tooltip>
  );
}
